import { Injectable, Injector } from "@angular/core";
import { BaseHttpService } from "./base-http.service";
import { FileState, FileInfo } from "@progress/kendo-angular-upload";
import { HttpErrorResponse } from "@angular/common/http";
import { CgpAlertDialogService } from "../cgp-alert-dialog/cgp-alert-dialog.service";
import { getEnv } from "src/modules/utility";
import { mescServicesUrl } from "src/app/components/mesc/config";

@Injectable()
export class S3Service extends BaseHttpService {
    private alertDialog: CgpAlertDialogService;
    constructor(injector: Injector) {
        super(injector);
        this.alertDialog = injector.get(CgpAlertDialogService);
    }

    /**
     * Construct url and call S3 service to remove file
     * @param file - file to remove
     * @param path - path to file e.g (CTWR/12345/)
     */
    handleS3Remove(file, path): Promise<any> {
        const url = this.getS3Url(s3config.methods.delete, path + file.name);
        return file.state === FileState.Uploaded ? this.delete(url, false) : Promise.resolve();
    }


    /**
     * Construct url and call s3 Service to copy file (recursive)
     * Attach body with source/destination info
     * @param file 
     * @param sourcePath 
     * @param destinationPath 
     */
    handleS3Copy(files: FileInfo[], sourcePath: string, destinationPath: string): Promise<any> {
        return Promise.all(
            files.map(f => {
                const path = `?sourcePath=${sourcePath}${f.name}&destinatonPath=${destinationPath}${f.name}`;
                const url = this.getS3Url(s3config.methods.copy, path);

                return this.post(null, url, false)
                    .then(x => f.state = FileState.Uploaded);
            }));
    }


    /**
     * For each file, call S3 service to upload file then toggle file state to Uploaded
     * @param files - List of files to upload
     * @param path - S3 path to file e.g.(CTWR/12345/)
     */

    handleS3Upload(files: FileInfo[], path: string, requestId = null): Promise<any> {
        return Promise.all(
            files.map(f => {
                const url = this.getS3Url(s3config.methods.upload, path + f.name);
                const formData: FormData = new FormData();
                formData.append('file', f.rawFile);

                return (f.state < 3) ?
                    this.upload(formData, url, false, null, requestId)
                        .then(x => f.state = FileState.Uploaded) :
                    Promise.resolve(null);
            }));
    }


    /**
     * 
     * @param filePath: e.g.(CTWR/12345/)
     */
    downloadS3Object = (file: FileInfo, path) => {
        if (!path) return;
        const url = this.getS3Url(s3config.methods.get, path + file.name);
        // const url = `https://cgp-wsvcs-uat.epg.nam.gm.com/api/S3Access/GetS3Object?s3Bucket=b0173294-002&s3ObjectKey=${path}${file.name}`;

        this.getS3Object(url)
            .then(blob => {
                const nav = (window.navigator as any)
                const url = window.URL.createObjectURL(blob);
                if (typeof navigator !== "undefined" && nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(blob, file.name);
                }
                else {
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = file.name;
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(this.handleS3Error)
    }


    /**
     * 
     */
    handleS3Error = (error: HttpErrorResponse) => {
        this.loading.next(false);
        if (error.status >= 200 && error.status < 400) return;
        if (this.alertDialog.isOpen()) return;
        this.alertDialog.showAlertDialog({
            title: `HTTP Error: ${error.status}`,
            message: error.message,
            alert: 'danger',
            closeLabel: 'OK'
        });
    }


    /**
     *  
     */
    getS3Url = (method: string, path = ''): string => {
        const baseUrl = mescServicesUrl[getEnv()];
        return `${baseUrl}${method}${path}`;
    }
}
export const s3config = {
    methods: {
        copy: 'ctwr/Request/CopyS3File',
        delete: 'ctwr/Request/S3Delete?filePath=',
        get: 'ctwr/Request/Downloadfile?fileName=',
        upload: 'ctwr/Request/Uploadfile?filePath=',
    },
}
